<!--
 * @Author: xiaokun
 * @Date: 2020-06-11 11:17:44
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-22 16:52:27
 * @Description: 关键词/商品标签 管理弹窗
-->
<template>
  <div class="common-setting-drawer">
    <wraped-drawer
      size="610px"
      :title="isKeyord ? '关键词管理' : '商品标签管理'"
      :visible="visible"
      :confirm-text="'确认'"
      @close="onClose"
      @on-confirm="onConfirm"
    >
      <div class="setting-content">
        <!-- 新增按钮 -->
        <div class="add-new-btn">
          <ds-iconfont icon-class="icon-mk-xinzeng2"></ds-iconfont>
          <div
            class="cursor"
            @click="handleOnOpenInput"
          >
            {{ isKeyord ? '新增关键词' : '新增商品标签' }}
          </div>
        </div>
        <!-- 新增输入框 -->
        <div
          v-if="isShowAddNewInput"
          class="add-new-input"
        >
          <mk-input
            v-model="addNewInput"
            width="320"
            :maxlength="'10'"
            show-word-limit
            :placeholder="isKeyord ? '请输入关键词' : '请输入商品标签'"
          />
          <div class="add-new-input-options">
            <span
              class="add-new-save cursor"
              @click="handleOnSaveNewClick"
            >保存</span>
            <span
              class="add-new-cancel cursor"
              @click="handleOnCancelNewClick"
            >取消</span>
          </div>
        </div>
        <!-- 关键词/商品标签列表 -->
        <div class="list">
          <div
            v-for="(item,index) in list"
            :key="item._id"
            @mouseover="handleHover(index)"
          >
            <list-item
              :ref="'listItem'+ item._id"
              :class="[index===listActive?'active':'']"
              :item-data="item"
              :index="index"
              :list-active="listActive"
              :is-keyord="isKeyord"
              @on-save-edit="onSaveEdit"
              @on-confim-delete="onConfimDelete"
            />
          </div>
        </div>
      </div>
      <div class="height-box" />
    </wraped-drawer>
  </div>
</template>
<script>
import WrapedDrawer from '../wraped-drawer'
import ListItem from './list-item'
export default {
  name: 'CommonSettingDrawer',
  components: { WrapedDrawer, ListItem },
  props: {
    // 弹窗是否展示
    visible: {
      type: Boolean,
      default: false
    },
    // 设置类型
    isSettingType: {
      type: String,
      default: ''
    },
    // 关键词
    keywordOptions: {
      type: Array,
      default () {
        return []
      }
    },
    // 商品标签
    tagsOptions: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      // 是否展示新增输入框
      isShowAddNewInput: false,
      // 新增 关键词/商品标签 内容
      addNewInput: '',
      // 循环数组内容
      list: [],
      listActive: null
    }
  },
  computed: {
    isKeyord () {
    //   关键词
      if (this.isSettingType === 'keyword') {
        this.list = this.keywordOptions
        return true
      } else {
        this.list = this.tagsOptions
        return false
      }
    }
  },
  methods: {
    // 聚焦
    handleHover (index) {
      if (index !== this.listActive) {
        this.listActive = index
      }
    },
    // 关闭设置弹窗
    onClose () {
      this.closeDrawer()
    },
    // 设置弹窗确认事件
    onConfirm () {
      this.closeDrawer()
    },
    // 弹窗关闭时所需要做的处理
    closeDrawer () {
      this.$emit('update:visible', false)
      // 关闭父级新建输入框 并清空值
      this.isShowAddNewInput = false
      this.addNewInput = ''
      // 关闭子级开启的编辑输入框
      let curId = this.util.storage.getItem('speech-storehouse-common-setting-drawer-id')
      if (curId) {
        let refsName = 'listItem' + curId
        this.$refs[refsName][0].closeParentDrawer()
      }

      // 移除编辑状态
      this.util.storage.removeItem('speech-storehouse-common-setting-drawer-id')
      this.util.storage.removeItem('speech-storehouse-common-setting-drawer')
    },
    // 打开新增关键词/商品标签的输入框
    handleOnOpenInput () {
      let isShowEditState = this.util.storage.getItem('speech-storehouse-common-setting-drawer')
      if (isShowEditState) {
        this.$message.error('请保存正在编辑内容后进行其他操作')
        return false
      } else {
        // 可打开
        this.isShowAddNewInput = true
        // 取消列表hover态
        this.listActive = null
        // 存入不可编辑状态
        this.util.storage.setItem('speech-storehouse-common-setting-drawer', true)
      }
    },
    // 新建关键词/商品标签 确认保存
    handleOnSaveNewClick () {
      if (this.addNewInput === '') {
        let content = this.isKeyord ? '请输入关键词' : '请输入商品标签'
        this.$message.error(content)
      } else {
        this.onConfirmAdd()
      }
    },
    async onConfirmAdd () {
      let params = {
        name: this.addNewInput
      }
      let res = null
      if (this.isKeyord) {
        res = await CONVERSATIONAPIS.KeyWordApi.pKeywordPost(params)
      } else {
        res = await CONVERSATIONAPIS.CommodityTagApi.pCommodityTagPost(params)
      }
      if (res.success) {
        this.successAdd()
      } else {
        let content = this.isKeyord ? '关键词已经存在' : '商品标签已经存在'
        this.$message.error(content)
      }
    },
    // 新增成功后的处理
    successAdd () {
      this.$message.success('添加成功')
      // 关闭新增输入框
      this.handleOnCancelNewClick()
    },

    // 新建关键词/商品标签 取消
    handleOnCancelNewClick () {
      // 更新数据
      this.updateDate()
      // 关闭输入框
      this.isShowAddNewInput = false
      // 取消不可编辑状态
      this.util.storage.setItem('speech-storehouse-common-setting-drawer', false)
      // 清空输入内容
      this.addNewInput = ''
    },

    // 保存编辑
    onSaveEdit (val) {
      let params = {
        _id: val._id,
        newName: val.newName,
        oldName: val.name
      }
      this.getSaveEditApi(params)
    },

    // 保存编辑 关键词/商品标签
    async getSaveEditApi (params) {
      let res = null

      if (this.isKeyord) {
        res = await CONVERSATIONAPIS.KeyWordApi.pKeywordPut(params)
      } else {
        res = await CONVERSATIONAPIS.CommodityTagApi.pCommodityTagPut(params)
      }
      if (res.success) {
        this.updateDate()
        this.$message.success('编辑成功')
      } else {
        this.$message.error(res.msg)
      }
    },

    // 编辑/删除/新增 操作成功后 提交父级更新数据
    updateDate () {
      if (this.isKeyord) {
        // 提交到父级 更新数据
        this.$emit('on-confirm-update-keyword')
      } else {
        // 提交到父级 更新数据
        this.$emit('on-confirm-update-commodity-tag')
      }
    },

    // 删除操作
    async onConfimDelete (val) {
      let params = {
        names: [val.name]
      }
      let res = null

      if (this.isKeyord) {
        res = await CONVERSATIONAPIS.KeyWordApi.pKeywordDelete(params)
      } else {
        res = await CONVERSATIONAPIS.CommodityTagApi.pCommodityTagDelete(params)
      }
      if (res.success) {
        this.updateDate()
        this.$message.success('删除成功')
      }
    }

  }
}
</script>
<style lang='scss' scoped>
.common-setting-drawer {
  .setting-content {
    padding: 20px;
    max-height: calc(100vh - 133px);
    overflow-y: scroll;

    .add-new-btn {
      font-size: 13px;
      color: #009cff;
      display: flex;

      .icon-mk-xinzeng2 {
        font-size: 12px;
        margin-right: 5px;
        color: #009cff;
      }
    }

    .add-new-input {
      padding: 0 10px;
      display: flex;
      align-items: center;
      margin-top: 16px;

      /deep/ .el-input__inner {
        padding-left: 12px;
      }

      .add-new-input-options {
        margin-left: 16px;
        font-size: 14px;

        .add-new-save {
          margin-right: 8px;
          color: #009cff;
        }

        .add-new-cancel {
          color: #888;
        }
      }
    }

    .list {
      margin-top: 8px;
    }
  }
}
</style>
